<template>
  <el-collapse
    v-if="normalizeCollapseOptionsCSS.length"
    v-model="collapseCSS"
    class="collapsed"
    :style="{ borderBottom: 'none' }"
    accordion
  >
    <el-collapse-item
      v-for="(item, index) in normalizeCollapseOptionsCSS"
      :key="index"
      :title="item.title"
      :name="item.name"
    >
      <div v-if="!item.hasChildCollapse">
        <component
          :is="element.eltype"
          v-for="(element, i) in item.items"
          :key="i"
          :title="element.title"
          :type="element.type"
          :default="element.default"
          :rgba="element.rgba"
          :parameter="element.parameter"
          :options="element.options"
          :status="element.status"
          :hint="element.hint"
          :min="element.min"
          :max="element.max"
          :integer="element.integer"
          :hint-status="element.hintStatus"
          :event-click="element.eventClick"
          :default-horizontal="element.defaultHorizontal"
          :default-vertical="element.defaultVertical"
          :default-blur="element.defaultBlur"
          :default-stretching="element.defaultStretching"
          :default-color="element.defaultColor"
          :default-inset="element.defaultInset"
          @changeOption="changeOption"
        />
      </div>
      <el-collapse
        v-if="item.hasChildCollapse"
        v-model="collapseChildCSS"
        class="collapsed child-collapse"
        accordion
      >
        <el-collapse-item
          v-for="(itemInner, ikey) in item.collapseChildOptions"
          :key="ikey"
          :title="itemInner.title"
          :name="itemInner.name"
        >
          <div v-if="!itemInner.hasChildCollapse">
            <component
              :is="element.eltype"
              v-for="(element, i) in itemInner.items"
              :key="i"
              :title="element.title"
              :type="element.type"
              :default="element.default"
              :rgba="element.rgba"
              :parameter="element.parameter"
              :options="element.options"
              :status="element.status"
              :hint="element.hint"
              :min="element.min"
              :max="element.max"
              :integer="element.integer"
              :hint-status="element.hintStatus"
              :event-click="element.eventClick"
              :default-horizontal="element.defaultHorizontal"
              :default-vertical="element.defaultVertical"
              :default-blur="element.defaultBlur"
              :default-stretching="element.defaultStretching"
              :default-color="element.defaultColor"
              :default-inset="element.defaultInset"
              @changeOptionCSS="changeOptionCSS"
              @changeOption="changeOption"
            />
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import ColorPickerCSS from "@/widgets/options_css/ColorPickerCSS";
import SliderCSS from "@/widgets/options_css/SliderCSS";
import NumberCSS from "@/widgets/options_css/NumberCSS";
import RadioCSS from "@/widgets/options_css/RadioCSS";
import ImageIconOpenCSS from "@/widgets/options_css/ImageIconOpenCSS";
import ImageIconCloseCSS from "@/widgets/options_css/ImageIconCloseCSS";
import Image360SpinCSS from "@/widgets/options_css/Image360SpinCSS";
import HintIconCSS from "@/widgets/options_css/HintIconCSS";
import VideoIconCSS from "@/widgets/options_css/VideoIconCSS";
import ModelIconCSS from "@/widgets/options_css/ModelIconCSS";
import BoxShadowCSS from "@/widgets/options_css/BoxShadowCSS";
import { mapState } from "vuex";
import { enabledField } from "@/mixins/enabledField.mixin";

import mixinQueryChangeParamsCSS from "@/store/observable/query-change-params-css";

import collapseCSS from "@/store/observable/option-elements-css";
import collapseChildCSS from "@/store/observable/option-elements-child-css";

export default {
  name: "CSSElements",
  components: {
    ColorPickerCSS,
    SliderCSS,
    NumberCSS,
    RadioCSS,
    ImageIconOpenCSS,
    ImageIconCloseCSS,
    Image360SpinCSS,
    HintIconCSS,
    VideoIconCSS,
    ModelIconCSS,
    BoxShadowCSS,
  },
  mixins: [enabledField, mixinQueryChangeParamsCSS],
  data() {
    return {
      queryChangeParamsCSS: [],
      queryChangeParams: null,
    };
  },
  computed: {
    ...mapState(["collapseOptionsCSS", "clearOptionsCSS", "clearOptions", "settings"]),
    normalizeCollapseOptionsCSS() {
      return this.collapseOptionsCSS.filter((it) => it.title !== "Dimensions");
    },
    collapseCSS,
    collapseChildCSS,
    optionsCopy() {
      return this.settings.options;
    },
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.queryChangeParams = null;
      }
    },
    collapseOptionsCSS(val) {
      this.queryChangeParamsCSS = [];
      this.queryChangeParams = null;
    },
    clearOptionsCSS(value) {},
  },
  methods: {
    checkZoomOption(params) {
      this.$store.dispatch("enableZoom", params);
    },
    changeOption(params) {
      this.$store.dispatch("video/setVideoThumbnailStatus", false);
      this.$store.dispatch("model/setModelThumbnailStatus", false);

      this.checkZoomOption(false);

      let options = this.optionsCopy.split(" ");

      if (options.includes("spin.thumbnail.type:gif;")) {
        options.splice(
          options.findIndex((e, i) => {
            e === "spin.thumbnail.type:gif;";
            return i;
          })
        );
      }

      if (
        options.includes(
          "spin.thumbnail.type:gif;spin.thumbnail.gifParams:image.rules=&image.pause=3000&image.speed=1000;"
        )
      ) {
        options.splice(
          options.findIndex((e, i) => {
            e ===
              "spin.thumbnail.type:gif;spin.thumbnail.gifParams:image.rules=&image.pause=3000&image.speed=1000;";
            return i;
          })
        );
      }

      if (
        options.includes(
          "spin.thumbnail.type:gif;spin.thumbnail.gifParams:image.rules=R60L120R60&image.speed=700&image.pause=3000;"
        )
      ) {
        options.splice(
          options.findIndex((e, i) => {
            e ===
              "spin.thumbnail.type:gif;spin.thumbnail.gifParams:image.rules=R60L120R60&image.speed=700&image.pause=3000;";
            return i;
          })
        );
      }

      if (params.value.length) {
        options.push(params.value);
      }

      this.$store.dispatch("changeOption", {
        option: options.join(" "),
      });
    },

    changeOptionCSS(params) {
      if (!params.value && !params.parameter) {
        this.queryChangeParamsCSS = [];
        this.$store.dispatch("changeOptionCSS", {
          optionCSS: this.queryChangeParamsCSS,
        });
        return;
      }

      if (params.value !== "") {
        let check = this.queryChangeParamsCSS.find((item) => {
          return item.parameter === params.parameter && item.type === params.type;
        });

        if (check === undefined) {
          this.queryChangeParamsCSS.push(params);
        } else {
          this.queryChangeParamsCSS.map((item) => {
            if (
              item &&
              item.hiddenType &&
              item.type === params.type &&
              item.parameter === params.parameter
            ) {
              item.type = params.type;
              item.parameter = params.parameter;
              item.value = params.value;
              item.separator = params.separator;
              item.hiddenType = params.hiddenType;
            } else if (item.type === params.type && item.parameter === params.parameter) {
              item.type = params.type;
              item.parameter = params.parameter;
              item.value = params.value;
              item.separator = params.separator;
            }

            if (params.noIconValue) {
              item.noIconValue = params.noIconValue;
            }

            return item;
          });
        }
      } else {
        let check = this.queryChangeParamsCSS.findIndex((item) => {
          return item.type === params.type && item.parameter === params.parameter;
        });

        if (check !== -1) {
          this.queryChangeParamsCSS.splice(check, 1);
        }
      }

      this.$store.dispatch("changeOptionCSS", {
        optionCSS: this.queryChangeParamsCSS,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-collapse .el-collapse-item.is-active {
  //border-bottom: 1px solid #EBEEF5 !important;
}
</style>
